var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5001,
    r: 12.5,
    fill: "white",
    stroke: "#CACDD8",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16298 19.9039H8.2377L11.6994 19.5884C12.0786 19.5506 12.4333 19.3836 12.7039 19.1152L20.1752 11.6439C20.4652 11.3375 20.6219 10.9287 20.611 10.507C20.6001 10.0853 20.4225 9.68515 20.1171 9.39418L17.8425 7.11957C17.5456 6.84072 17.1566 6.68072 16.7495 6.67001C16.3423 6.65929 15.9454 6.79861 15.6343 7.06146L8.16298 14.5328C7.89465 14.8034 7.72757 15.1581 7.6898 15.5373L7.33283 18.999C7.32165 19.1206 7.33743 19.2431 7.37904 19.3579C7.42065 19.4727 7.48708 19.5769 7.57358 19.6631C7.65115 19.7401 7.74314 19.8009 7.84428 19.8422C7.94543 19.8836 8.05373 19.9045 8.16298 19.9039ZM16.6886 8.28178L18.9549 10.5481L17.2946 12.1669L15.0698 9.94208L16.6886 8.28178ZM9.30029 15.6784L13.974 11.0379L16.2154 13.2793L11.5666 17.9281L9.07615 18.1605L9.30029 15.6784Z",
    fill: "#A2A6B0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.35123a03343abbf67eb07557ccf9b6d4.svg";
export { ForwardRef as ReactComponent };